export default __webpack_public_path__ + "static/media/balance-auto-optional-attendee.4b22d439.md";